import { render, staticRenderFns } from "./FollowUpEdit.vue?vue&type=template&id=46c66d06&"
import script from "./FollowUpEdit.vue?vue&type=script&lang=js&"
export * from "./FollowUpEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports